var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProductsFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_63228",
    "data-name": "Group 63228",
    xmlns: "http://www.w3.org/2000/svg",
    width: 325.114,
    height: 180.395,
    viewBox: "0 0 325.114 180.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_221341",
    "data-name": "Path 221341",
    d: "M273.738,109.051h0c0-12.047-10.617-21.814-23.713-21.814H223.377c-13.1,0-23.713-9.767-23.713-21.814h0c0-12.047,10.617-21.814,23.713-21.814h56.8c13.1,0,23.712-9.767,23.712-21.814h0c0-12.047-10.617-21.814-23.712-21.814H94.37c-13.1,0-23.713,9.767-23.713,21.814h0c0,12.047-10.617,21.814-23.713,21.814H23.713C10.617,43.609,0,53.376,0,65.424H0C0,77.471,10.617,87.238,23.713,87.238H68.4c13.1,0,23.713,9.767,23.713,21.814h0c0,12.047-10.617,21.814-23.713,21.814H45.387c-13.1,0-23.713,9.767-23.713,21.814h0c0,12.047,10.617,21.814,23.713,21.814H301.4c13.1,0,23.713-9.767,23.713-21.814h0c0-12.048-10.617-21.814-23.713-21.814h-3.951c-13.1,0-23.713-9.767-23.713-21.814Z",
    transform: "translate(0 0.02)",
    fill: "#f1f1f1",
    opacity: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_89437634_Seamless_Shipping_Transportation_and_Logistics_Integration",
    "data-name": "89437634_Seamless Shipping Transportation and Logistics Integration",
    transform: "translate(64.193 36.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63213",
    "data-name": "Group 63213",
    transform: "translate(-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221484",
    "data-name": "Path 221484",
    d: "M1473.485,1443.084h21.781v66.232h-21.781Z",
    transform: "translate(-1258.656 -1365.021)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221485",
    "data-name": "Path 221485",
    d: "M1554.879,1460.4h4.538v16.873h-4.538Z",
    transform: "translate(-1325.711 -1379.291)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63214",
    "data-name": "Group 63214",
    transform: "translate(-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221488",
    "data-name": "Path 221488",
    d: "M1430.212,1649.914h25.774v29.795h-25.774Z",
    transform: "translate(-1223.007 -1535.416)",
    fill: "#898989",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221489",
    "data-name": "Path 221489",
    d: "M1537.364,1661.12h4.719v9.334h-4.719Z",
    transform: "translate(-1311.282 -1544.648)",
    fill: "#aaa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63215",
    "data-name": "Group 63215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221482",
    "data-name": "Path 221482",
    d: "M1201.485,1595.911h35.756v39.308h-35.756Z",
    transform: "translate(-1033.573 -1490.926)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221483",
    "data-name": "Path 221483",
    d: "M1328.212,1608.136h10.89v5.206h-10.89Z",
    transform: "translate(-1137.976 -1500.998)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61101",
    "data-name": "Group 61101",
    transform: "translate(23.385 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221319",
    "data-name": "Path 221319",
    d: "M1510.269,1538.564H1641.2v-2.125H1510.269Z",
    transform: "translate(-1509.664 -1467.523)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221827",
    "data-name": "Path 221827",
    d: "M1510.269,1538.564H1641.2v-2.125H1510.269Z",
    transform: "translate(-1509.664 -1399.391)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221320",
    "data-name": "Path 221320",
    d: "M1510.269,1131.659H1640.49v-1.95H1510.269Z",
    transform: "translate(-1509.664 -1097.274)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221321",
    "data-name": "Path 221321",
    d: "M1495.741,897.293h2.242V760.473c0-.747-.3-1.353-.672-1.353h-1.57Z",
    transform: "translate(-1495.741 -759.12)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221322",
    "data-name": "Path 221322",
    d: "M3181.1,909.237h2.475V766.423h-1.733c-.41,0-.742.647-.742,1.446Z",
    transform: "translate(-3051.474 -766.119)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61140",
    "data-name": "Group 61140",
    transform: "translate(3.838 3.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61148",
    "data-name": "Group 61148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61144",
    "data-name": "Group 61144",
    transform: "translate(98.889 40.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478",
    "data-name": "Path 221478",
    d: "M1056.17,1665.195h-24.685v22.322h24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61141",
    "data-name": "Group 61141",
    transform: "translate(34.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-2",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h30.647v27.1h-30.647Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-2",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1106.159 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61145",
    "data-name": "Group 61145",
    transform: "translate(65.575 36.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-3",
    "data-name": "Path 221478",
    d: "M1062.132,1665.195h-30.647v27.1h30.647Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-3",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61142",
    "data-name": "Group 61142",
    transform: "translate(68.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-4",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v33.115h-24.685Z",
    transform: "translate(-1031.484 -1671.209)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-4",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1112.12 -1684.637)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61143",
    "data-name": "Group 61143",
    transform: "translate(96.223 8.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-5",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h27.35v18.357h-27.35Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-5",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v7.686h-4.719Z",
    transform: "translate(-1109.455 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61147",
    "data-name": "Group 61147",
    transform: "translate(0 40.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-6",
    "data-name": "Path 221478",
    d: "M1065.9,1665.195h-34.416v22.322H1065.9Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-6",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63211",
    "data-name": "Group 63211",
    transform: "translate(3.838 76.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61148-2",
    "data-name": "Group 61148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61140-2",
    "data-name": "Group 61140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-7",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-7",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1112.121 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61144-2",
    "data-name": "Group 61144",
    transform: "translate(98.889 25.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-8",
    "data-name": "Path 221478",
    d: "M1056.17,1665.195h-24.685v33.621h24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-8",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v8.223h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61141-2",
    "data-name": "Group 61141",
    transform: "translate(27.351 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-9",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h30.647v27.1h-30.647Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-9",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1106.159 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61145-2",
    "data-name": "Group 61145",
    transform: "translate(65.575 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-10",
    "data-name": "Path 221478",
    d: "M1062.132,1665.195h-30.647v27.1h30.647Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-10",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61142-2",
    "data-name": "Group 61142",
    transform: "translate(61.373 10.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-11",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v19.82h-24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-11",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v9.035h-4.719Z",
    transform: "translate(-1112.121 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61146",
    "data-name": "Group 61146",
    transform: "translate(37.516 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-12",
    "data-name": "Path 221478",
    d: "M1056.17,1665.195h-24.685v27.1h24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-12",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61147-2",
    "data-name": "Group 61147",
    transform: "translate(0 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-13",
    "data-name": "Path 221478",
    d: "M1065.9,1665.195h-34.416v27.1H1065.9Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-13",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61139",
    "data-name": "Group 61139",
    transform: "translate(141.963 117.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-14",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-14",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1112.121 -1678.623)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221480",
    "data-name": "Path 221480",
    d: "M1031.485,1548.031h17.243v20.64h-17.243Z",
    transform: "translate(-886.522 -1451.48)",
    fill: "#b1b1b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61134",
    "data-name": "Group 61134",
    transform: "translate(169.726 117.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221490",
    "data-name": "Path 221490",
    d: "M1211.788,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1211.788 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221491",
    "data-name": "Path 221491",
    d: "M1221.061,1673.344h5.264v3.051h-5.264Z",
    transform: "translate(-1219.428 -1671.908)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221481",
    "data-name": "Path 221481",
    d: "M1093.3,1565.349h5.264v3.23H1093.3Z",
    transform: "translate(-940.45 -1465.747)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63212",
    "data-name": "Group 63212",
    transform: "translate(13461.772 17502.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221108",
    "data-name": "Path 221108",
    d: "M1130.64,2017.423l8.908-.668.7,8.5-8.908.668Zm0,0",
    transform: "translate(-14559.561 -19439.01)",
    fill: "#998cce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221110",
    "data-name": "Path 221110",
    d: "M1148.433,2243.991l8.908-.668.7,8.495-8.908.669Zm0,0",
    transform: "translate(-14576.218 -19651.783)",
    fill: "#e9eef7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221112",
    "data-name": "Path 221112",
    d: "M1166.275,2470.556l8.908-.668.7,8.5-8.908.668Zm0,0",
    transform: "translate(-14592.921 -19864.557)",
    fill: "#998cce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221115",
    "data-name": "Path 221115",
    d: "M654.995,2264.113l-40.116.161,34.911,2.813,49.345-1.906Zm0,0",
    transform: "translate(-14076.725 -19671.309)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221342",
    "data-name": "Path 221342",
    d: "M1552.89,1835.583h-6.925a.463.463,0,0,0-.418.5v3.565a.463.463,0,0,0,.418.5h6.925a.463.463,0,0,0,.418-.5v-3.565a.463.463,0,0,0-.418-.5Zm0,0",
    transform: "translate(-14992.948 -19273.422)",
    fill: "#9b9b9b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63199",
    "data-name": "Group 63199",
    transform: "translate(-13434.534 -17446.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221116",
    "data-name": "Path 221116",
    d: "M1049.566,1708.315h-4.981a1.838,1.838,0,0,1-1.875-1.789v-26.141c0-1.756,3.1-1.917,3.163-2.9l1.023-15.715-.916-.693.3-3.107h6.584l.3,3.107-.915.693,1.022,15.715c.065.984,3.164,1.145,3.164,2.9v26.141a1.838,1.838,0,0,1-1.875,1.789Zm0,0",
    transform: "translate(-1042.71 -1655.336)",
    fill: "#b9b9b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221117",
    "data-name": "Path 221117",
    d: "M1135.493,1687l.013-.213-.074-.059,1.087-1.306h1.542l.067.69-.892.672Zm1.742-.21,1.081,16.582c.088,1.322,1.149,1.832,2.187,2.361.594.3,1.094.625.974,2.16v23.461a.124.124,0,0,1-.123.118h-1.233V1707.8c0-1.566-.87-1.5-1.827-2.173a2.9,2.9,0,0,1-1.308-2.64Zm0,0",
    transform: "translate(-1129.513 -1681.115)",
    fill: "#939393",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29924",
    "data-name": "Rectangle 29924",
    width: 13.717,
    height: 16.523,
    transform: "translate(0 28.052)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221118",
    "data-name": "Path 221118",
    d: "M1090.2,2103.632c-2.259,0-4.089,2.93-4.089,6.548s1.83,6.548,4.089,6.548,4.085-2.933,4.085-6.548-1.83-6.548-4.085-6.548Zm0,0",
    transform: "translate(-1083.338 -2073.866)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221343",
    "data-name": "Path 221343",
    d: "M1552,1835.583h-6.087c-.2,0-.368.223-.368.5,0,3.837.145,4.033.17,4.06h6.736l-.084-4.06c0-.273-.165-.5-.368-.5Zm0,0",
    transform: "translate(-1542.211 -1835.583)",
    fill: "#9b9b9b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63196",
    "data-name": "Group 63196",
    transform: "translate(-13409.347 -17433.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221119",
    "data-name": "Path 221119",
    d: "M1554.659,1835.583h-8.593a.509.509,0,0,0-.519.5v3.565a.509.509,0,0,0,.519.5h8.593a.509.509,0,0,0,.519-.5v-3.565a.509.509,0,0,0-.519-.5Zm0,0",
    transform: "translate(-1538.634 -1835.583)",
    fill: "#9b9b9b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29925",
    "data-name": "Rectangle 29925",
    width: 6.47,
    height: 1.671,
    transform: "translate(8.321 4.556)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221120",
    "data-name": "Path 221120",
    d: "M1438.481,1937.86h20.681a1.192,1.192,0,0,1,1.217,1.157v35.3a1.193,1.193,0,0,1-1.217,1.157h-20.681a1.191,1.191,0,0,1-1.214-1.157v-35.3a1.189,1.189,0,0,1,1.214-1.157Zm0,0",
    transform: "translate(-1437.267 -1931.632)",
    fill: "#a3a3a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221121",
    "data-name": "Path 221121",
    d: "M1480.424,2133.369c-5.193,0-9.4,2.6-9.4,5.8s4.209,5.806,9.4,5.806,9.4-2.6,9.4-5.806-4.209-5.8-9.4-5.8Zm0,0",
    transform: "translate(-1468.868 -2115.239)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60839",
    "data-name": "Group 60839",
    transform: "translate(-13426.395 -17427.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63198",
    "data-name": "Group 63198",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221122",
    "data-name": "Path 221122",
    d: "M1148.4,1846.449l-8.017,1.292-1.875.544L1128,1820.92l4.535-1.318,8.016-2.323,4.537-1.315,5.867,29.451Zm0,0",
    transform: "translate(-1127.997 -1815.963)",
    fill: "#d6d6d6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60838",
    "data-name": "Group 60838",
    transform: "translate(3.88 7.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221123",
    "data-name": "Path 221123",
    d: "M1241.3,1931.793c-2.885.782-3.962,5.638-2.411,10.846s5.15,8.792,8.036,8.012,3.962-5.639,2.41-10.847-5.153-8.8-8.035-8.012Zm0,0",
    transform: "translate(-1235.498 -1931.685)",
    fill: "#b9b9b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221124",
    "data-name": "Path 221124",
    d: "M1393.6,2003.99a17.3,17.3,0,0,0-1.318-3.215l2.732-.743,1.285,6.709-2.054.56a17.139,17.139,0,0,0-.646-3.312Zm0,0",
    transform: "translate(-1379.765 -1995.871)",
    fill: "#939393",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221125",
    "data-name": "Path 221125",
    d: "M1198.948,2055.8a17.553,17.553,0,0,0,1.931,6.536l-2.054.558-2.609-6.35Zm0,0",
    transform: "translate(-1196.216 -2048.24)",
    fill: "#939393",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29926",
    "data-name": "Rectangle 29926",
    width: 14.141,
    height: 33.718,
    transform: "translate(-13447.817 -17428.586)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221126",
    "data-name": "Path 221126",
    d: "M753.828,1890.5l-5.51-1.442v33.717l5.51,1.442Zm0,0",
    transform: "translate(-14201.645 -19319.09)",
    fill: "#aaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221127",
    "data-name": "Path 221127",
    d: "M848.777,1861.525H834.635l.415-3.321h7.762Zm0,0",
    transform: "translate(-14282.452 -19290.111)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221128",
    "data-name": "Path 221128",
    d: "M753.828,1861.526l-5.51-1.442,5.926-1.879Zm0,0",
    transform: "translate(-14201.645 -19290.111)",
    fill: "#aaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29927",
    "data-name": "Rectangle 29927",
    width: 7.762,
    height: 1.649,
    transform: "translate(-13447.401 -17433.555)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221132",
    "data-name": "Path 221132",
    d: "M1211.1,2281.649l-49.345,1.906v46.1l49.345-3.357Zm0,0",
    transform: "translate(-14588.685 -19687.775)",
    fill: "#d8d8d8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221133",
    "data-name": "Path 221133",
    d: "M614.879,2266.757l34.911,2.813v46.1l-34.911-5.9Zm0,0",
    transform: "translate(-14076.725 -19673.791)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221134",
    "data-name": "Path 221134",
    d: "M839.006,2774.332v14.53l6.3,1.083v-14.7Zm0,0",
    transform: "translate(-14286.544 -20150.465)",
    fill: "#aaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221135",
    "data-name": "Path 221135",
    d: "M1219.773,2290.72l-53.129,3.667-4.894-10.832,49.345-1.906Zm0,0",
    transform: "translate(-14588.685 -19687.775)",
    fill: "#b5b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221136",
    "data-name": "Path 221136",
    d: "M536.581,2282.117l7.847-12.547-34.911-2.813-7.185,9.234Zm0,0",
    transform: "translate(-13971.362 -19673.791)",
    fill: "#aaa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60842",
    "data-name": "Group 60842",
    transform: "translate(127.814 -11.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221154",
    "data-name": "Path 221154",
    d: "M1596.589,2598.226l28.954,47.819a3.1,3.1,0,0,1-1.23,4.337,3.47,3.47,0,0,1-1.666.423v.012h-58.093a3.273,3.273,0,0,1-3.351-3.189,3.074,3.074,0,0,1,.572-1.785l28.934-47.794a3.433,3.433,0,0,1,4.567-1.16,3.229,3.229,0,0,1,1.313,1.337Zm0,0",
    transform: "translate(-1561.203 -2596.459)",
    fill: "#777",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221155",
    "data-name": "Path 221155",
    d: "M1638.131,2651.264l-25.943,42.851h49.861v-.019h2.011Zm0,0",
    transform: "translate(-1605.736 -2644.65)",
    fill: "#b1b1b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221156",
    "data-name": "Path 221156",
    d: "M1792.284,2763.1h4.7a.883.883,0,0,1,.913.871l-.971,16.784a.913.913,0,0,1-.914.871h-2.753a.913.913,0,0,1-.913-.871l-.972-16.784a.881.881,0,0,1,.914-.871Zm2.348,20.293a2.6,2.6,0,1,1-2.721,2.6,2.667,2.667,0,0,1,2.721-2.6Zm0,0",
    transform: "translate(-1762.244 -2742.99)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProductsFound);
export default __webpack_public_path__ + "static/media/noProductsFound.48563eca116d6edbad3d4f6a94a55e0a.svg";
export { ForwardRef as ReactComponent };